import { DataMapStructure } from './data-map';

export const indexingRatingDataMap: DataMapStructure = {
  1: { key: 'REPORTDATA.lowRisk', fallback: 'Low Risk' },
  2: { key: 'REPORTDATA.mediumRisk', fallback: 'Medium Risk' },
  3: { key: 'REPORTDATA.highRisk', fallback: 'High Risk' },
  4: { key: 'REPORTDATA.very_high', fallback: 'Very High Risk' },
};
